import * as l10n from '@/constants/l10n';
import { localize } from '@/filters/localize';
import Vue from 'vue';
export const GoToCartEntry = Vue.extend({
    functional: true,
    name: 'GoToCartEntry',
    props: {
        shoppingCartUrl: String,
    },
    render(createElement, { props }) {
        return (<li class="d-flex justify-content-center pl-4 pr-4 pt-3 pb-2">
                <a href={props.shoppingCartUrl} class="btn btn-primary w-100 shopping-cart-menu__go-to-cart">
                    {localize(l10n.SHOPPING_CART_MENU.GO_TO_CART)}
                </a>
            </li>);
    },
});
//# sourceMappingURL=GoToCartEntry.jsx.map